<template>
  <v-container fluid fill-height>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :extension-height="displayFilter?131:53">
            <v-toolbar-title>
              <v-icon left color="accent">mdi-clipboard-text</v-icon>Prescriptions
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn outlined @click="displayFilter=!displayFilter" class="mr-2">{{ displayFilter ? 'Hide Filters':'Show Filters' }}</v-btn>
            <v-btn outlined color="accent" @click="formOpen = true">
              <v-icon>mdi-plus</v-icon>Add Prescription
            </v-btn>
            <template v-slot:extension class="pa-0" >
              <v-container fluid class="ma-0 pa-0">
                <v-row v-if="displayFilter">
                  <v-col cols="2">
                    <shop-select
                      v-model="shopId"
                      style="align-items:center"
                      clearable
                    ></shop-select>
                  </v-col>
                  <v-col cols="2">
                    <fitter-select
                      v-model="clubFitterId"
                      style="align-items:center"
                      clearable
                    ></fitter-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-tabs v-model="tabs">
                      <v-tab>New</v-tab>
                      <v-tab>Quoted</v-tab>
                      <v-tab>Ready To Build</v-tab>
                      <v-tab>Built</v-tab>
                      <v-tab>Shipped</v-tab>
                      <v-tab>All</v-tab>
                    </v-tabs>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <prescription-list
                :headers="headers"
                :tabs="tabs"
                :filters="{ statusId: 'new', shopId: shopId, clubFitterId }"
              ></prescription-list>
            </v-tab-item>
            <v-tab-item>
              <prescription-list
                :headers="headers"
                :tabs="tabs"
                :filters="{ statusId: 'quoted', shopId: shopId, clubFitterId }"
              ></prescription-list>
            </v-tab-item>
            <v-tab-item>
              <prescription-list
                :headers="headers"
                :tabs="tabs"
                :filters="{ statusId: 'readyToBuild', shopId: shopId, clubFitterId }"
              ></prescription-list>
            </v-tab-item>
            <v-tab-item>
              <prescription-list
                :headers="headers"
                :tabs="tabs"
                :filters="{ statusId: 'built', shopId: shopId, clubFitterId }"
              ></prescription-list>
            </v-tab-item>
            <v-tab-item>
              <prescription-list
                :headers="headers"
                :tabs="tabs"
                :filters="{ statusId: 'shipped', shopId: shopId, clubFitterId }"
              ></prescription-list>
            </v-tab-item>
            <v-tab-item>
              <prescription-list
                :headers="headers"
                :tabs="tabs"
                :filters="{ statusId: 'shipped', shopId: shopId, clubFitterId }"
              ></prescription-list>
            </v-tab-item>
          </v-tabs-items>
          <prescription-add-form
            :open="formOpen"
            v-on:cancel="cancel()"
            v-on:add="create($event)"
          ></prescription-add-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ShopSelect from "@components/forms/select/Shop.vue";
import FitterSelect from "@components/forms/select/Fitter.vue";
import PrescriptionList from "@components/prescriptions/PrescriptionList.vue";
import PrescriptionAddForm from "@components/prescriptions/PrescriptionAddForm.vue";
import hasQueryParams from '../../mixins/hasQueryParams.vue';

export default {
  name: 'PrescriptionTabList',
  mixins: [hasQueryParams],
  components: {
    PrescriptionList,
    PrescriptionAddForm,
    ShopSelect,
    FitterSelect,
  },
  data() {
    return {
      displayFilter:false,
      tabs: false,
      formOpen: false,
      shopId: null,
      clubFitterId: null,
      headers: [
        { text: "Id", value: "id", align: "center" },
        { text: "Shop", value: "shopId", align: "left" },
        { text: "Customer", value: "clientId", align: "left" },
        { text: "Status", value: "statusId", align: "center" },
        { text: "Club Fitter", value: "clubFitterId" },
        { text: "Fitting Date", value: "fittingDate", align: "center" },
        { text: "Updated", value: "updated_at", align: "left" },
        { text: "Actions", value: "action", align: "left" },
      ],
      queryFields: ['shopId', 'clubFitterId', 'prescriptionTabs'],
    };
  },
  mounted: function() {
    this.parseQuery()
  },
  computed: {
    query () {
      return {
        shopId: this.shopId ? this.shopId.toString() : null,
        clubFitterId: this.clubFitterId ? this.clubFitterId.toString() : null,
        prescriptionTabs: this.tabs
      }
    }
  },
  watch: {
    shopId () {
      this.pushNewRoute()
    },
    tabs () {
      this.pushNewRoute()
    }
  },
  methods: {
    parseQuery(){
      this.shopId = this.$route.query.shopId ? parseInt(this.$route.query.shopId): null
      this.tabs = this.$route.query.prescriptionTabs ? parseInt(this.$route.query.prescriptionTabs): 0
      this.clubFitterId = this.$route.query.clubFitterId ? parseInt(this.$route.query.clubFitterId): null
    },
    cancel() {
      this.formOpen = false;
      this.getPrescriptions();
    },
    create(id) {
      this.formOpen = false;
      this.open(id);
    },
    open(id) {
      this.$router.push("/prescription/view/" + id);
    },
  },
};
</script>
